// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-3adac06c]{display:flex;align-items:center;padding:8px 20px;background-color:#fff;border-radius:3px;margin:20px 0}.btn+.btn[data-v-3adac06c]{margin-left:20px}", ""]);
// Exports
module.exports = exports;
